__turbopack_context__.v({
  "container": "phoneFieldFormik-module-scss-module__sUAISa__container",
  "error-msg": "phoneFieldFormik-module-scss-module__sUAISa__error-msg",
  "error-msg-hide": "phoneFieldFormik-module-scss-module__sUAISa__error-msg-hide",
  "phoneField": "phoneFieldFormik-module-scss-module__sUAISa__phoneField",
  "phoneField-disabled-true": "phoneFieldFormik-module-scss-module__sUAISa__phoneField-disabled-true",
  "phoneField-error": "phoneFieldFormik-module-scss-module__sUAISa__phoneField-error",
  "phoneInputField": "phoneFieldFormik-module-scss-module__sUAISa__phoneInputField",
});
